import { render, staticRenderFns } from "./IntrastatPurchases.vue?vue&type=template&id=199946a6"
import script from "./IntrastatPurchases.vue?vue&type=script&lang=js"
export * from "./IntrastatPurchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports